const HierarchicalComponent = (props) => {
    const style = {
        marginTop: 50,
        width: '90%',
        textAlign: 'center'
    };

    return (
        <>
            <p style={style}>
                O componente do orquestrador hierárquico deve ser configurado apenas através do Gerenciador.
            </p>
        </>
    );
};  

export default HierarchicalComponent; 